import {AxiosError, AxiosResponse} from "axios";

export enum RemoteRequestStatesEnum {
  Ready,
  Loading,
  Loaded,
  LoadingError
}

export class RemoteRequestState {
  state: RemoteRequestStatesEnum = RemoteRequestStatesEnum.Ready;

  get isLoading() {
    return this.state == RemoteRequestStatesEnum.Loading;
  }

  get isLoaded() {
    return this.state == RemoteRequestStatesEnum.Loaded;
  }

  get isError() {
    return this.state == RemoteRequestStatesEnum.LoadingError;
  }

  get isReady() {
    return this.state == RemoteRequestStatesEnum.Ready;
  }

  reset() {
    this.state = RemoteRequestStatesEnum.Ready;
  }

  start = () => {
    this.loadStart();
  }

  end = () => {
    this.loadEnd();
  }

  error = () => {
    this.loadError();
  }

  loadStart() {
    this.state = RemoteRequestStatesEnum.Loading;
  }

  loadEnd() {
    this.state = RemoteRequestStatesEnum.Loaded;
  }

  loadError() {
    this.state = RemoteRequestStatesEnum.LoadingError;
  }
}

// Костыль для того, чтобы не писать везде new RemoteRequestState()
export const useAsyncHook = (asyncFunction, immediate = false) => {
  let error = null;
  const loadingStatus = new RemoteRequestState();
  let result = null;
  let promise = null;

  const execute = (...rest) => {
    error = null;
    loadingStatus.loadStart();
    return promise = asyncFunction(...rest)
      .then((response) => {
        loadingStatus.loadEnd();
        result = response;
        return result;
      })
      .catch((e) => {
        loadingStatus.loadError();
        error = e;
        throw e;
      })
    // .finally(() => {
    //   loadingStatus.loadEnd();
    // });
  }

  if (immediate) {
    promise = execute();
  }

  return {
    execute, promise,
    loadingStatus, error
  };
}


/**
 * Makes a request with retries
 * @param asyncFunction
 * @param maxRetries
 * @param interval
 * @param httpErrorCodes
 */
export const makeRequestWithRetry = async (
  asyncFunction: () => Promise<any|AxiosResponse<any, any>>,
  maxRetries: number = 3,
  interval: number = 1000, // Default interval of 5 seconds
  httpErrorCodes: number[] = [500, 502, 503, 504],
): Promise<any|AxiosResponse<any, any>> => {
  let retries = 0;

  while (retries < maxRetries) {
    try {
      const response = await asyncFunction();
      return response.data;
    } catch (error) {
      const axiosError = error as AxiosError;

      // Check if the error is due to one of the specified HTTP error codes
      if (
        axiosError.response &&
        httpErrorCodes.includes(axiosError.response.status)
      ) {
        retries++;

        if (retries >= maxRetries) {
          throw axiosError;
        }

        // Add an interval between retries
        await new Promise((resolve) => setTimeout(resolve, interval));
      } else {
        // If it's not one of the specified error codes, rethrow the error
        throw axiosError;
      }
    }
  }

  throw new Error('Max retries reached.');
}
